import { render, staticRenderFns } from "./PaidCargoVolumeColumn.vue?vue&type=template&id=719ec5c6&"
import script from "./PaidCargoVolumeColumn.vue?vue&type=script&lang=js&"
export * from "./PaidCargoVolumeColumn.vue?vue&type=script&lang=js&"
import style0 from "./PaidCargoVolumeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719ec5c6')) {
      api.createRecord('719ec5c6', component.options)
    } else {
      api.reload('719ec5c6', component.options)
    }
    module.hot.accept("./PaidCargoVolumeColumn.vue?vue&type=template&id=719ec5c6&", function () {
      api.rerender('719ec5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/PaidCargoVolumeColumn.vue"
export default component.exports